module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/0b541f3d1a6e8b2dd7839ffa37fd3f08.png";